import { Pipe, PipeTransform } from "@angular/core";
import moment from "moment";
import "moment/locale/es";

@Pipe({ name: "availableDatePipe", standalone: true })
export class AvailableDatePipe implements PipeTransform {
  transform(value: string | Date): string {
    moment.locale("es");

    const date = moment(value, ["YYYY-MM-DD", "DD/MM/YYYY"], true);

    if (!date.isValid()) {
      return "Fecha inválida";
    }

    return date
      .format("dddd DD [de] MMMM")
      .replace(/^\w/, (c) => c.toUpperCase());
  }
}
